import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const SignOutConfirmation = ({ showModal, onClose, onSignOut }) => {
  return (
    <Modal show={showModal} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Sign Out</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to sign out?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onSignOut}>
          Sign Out
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SignOutConfirmation;
